module.exports = __webpack_public_path__ + "fonts/moods.7e68712.ttf";